import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';
import {Directive, Input} from '@angular/core';

@Directive({
    selector: '[nlrMaxDate]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: NlrMaxDateValidatorDirective,
            multi: true
        }
    ],
    standalone: true
})
export class NlrMaxDateValidatorDirective implements Validator {
    @Input('nlrMaxDate')
    maxDate: string;

    validate(control: AbstractControl): ValidationErrors | null {
        if (this.maxDate && control.value && new Date(control.value).getTime() > new Date(this.maxDate).getTime()) {
            return {nlrMaxDate: true};
        }
        return null;
    }
}
